export default __webpack_public_path__ + "static/media/trust.5db29c5a.svg";